import { Companion_getInstance36v07euvaglly as Companion_getInstance } from '../ByteString.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var UnsafeByteStringOperationsClass;
function UnsafeByteStringOperations() {
  if (UnsafeByteStringOperationsClass === VOID) {
    class $ {
      d4f(array) {
        return Companion_getInstance().y4e(array);
      }
    }
    initMetadataForObject($, 'UnsafeByteStringOperations');
    UnsafeByteStringOperationsClass = $;
  }
  return UnsafeByteStringOperationsClass;
}
var UnsafeByteStringOperations_instance;
function UnsafeByteStringOperations_getInstance() {
  return UnsafeByteStringOperations_instance;
}
//region block: init
UnsafeByteStringOperations_instance = new (UnsafeByteStringOperations())();
//endregion
//region block: exports
export {
  UnsafeByteStringOperations_instance as UnsafeByteStringOperations_instance32go50d8u0bll,
};
//endregion

//# sourceMappingURL=UnsafeByteStringOperations.mjs.map
